import { useRegisterBreadcrumbs } from '@/services/breadcrumbs';
import { useObjectDetail } from './context';

type UseAttributesBreadcrumbsOptions = {
  /** Append the edit crumb after Attributes. */
  withEdit?: boolean;
};

/**
 * The Attributes crumb (and, on the edit page, Edit) under the object crumb the
 * detail shell registers. The store orders crumbs by href depth, so the edit page
 * registers both and still reads "… / Attributes / Edit".
 */
export function useAttributesBreadcrumbs({ withEdit = false }: UseAttributesBreadcrumbsOptions = {}) {
  const { hrefs } = useObjectDetail();

  useRegisterBreadcrumbs([
    { id: 'object.attributes', text: 'Attributes', href: hrefs.tabs.attributes },
    ...(withEdit ? [{ id: 'object.attributes.edit', text: 'Edit', href: hrefs.attributesEdit }] : []),
  ]);
}
